import { render, staticRenderFns } from "./new-prescription.vue?vue&type=template&id=38a2cd95&"
import script from "./new-prescription.vue?vue&type=script&lang=js&"
export * from "./new-prescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports